module.exports = __webpack_public_path__ + "static/media/logo_dev.6df8e653.png";